import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['accordionItem', 'content']

  className () {
    return this.element.dataset.classname
  }

  connect () {
    // 最初のアコーディオンを開いた状態にする
    if (this.accordionItemTargets.length > 0) {
      this.accordionItemTargets[0].classList.add(`${this.className()}::accordion-item--open`)
    }
  }

  toggle (event) {
    const button = event.currentTarget
    const accordionItem = button.closest(`[data-${this.identifier}-target="accordionItem"]`)

    if (accordionItem) {
      accordionItem.classList.toggle(`${this.className()}::accordion-item--open`)
    }
  }
}
